import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import plugins from './plugins';
import { state } from './state';
import router from '../routes';
import { sync } from 'vuex-router-sync';

import webPanel from '@/core/shared/web-panel/store';
import auth from '@/core/shared/auth/store';
import publicModule from '@/public/store';
import publicKioskModule from '@/public/kiosk/store';
import booking from '@/panel/booking/store';
import waivers from '@/panel/waivers/store';

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins,
  modules: {
    webPanel,
    auth,
    public: publicModule,
    booking,
    waivers,
    kiosk: publicKioskModule,
  },
});

if (module.hot) {
  module.hot.accept([
    './getters',
    './actions',
    './mutations',
  ], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      mutations: require('./mutations'),
      modules: {
        webPanel: require('@/core/shared/web-panel/store'),
        auth: require('@/core/shared/auth/store'),
        public: require('@/public/store'),
        booking: require('@/panel/booking/store'),
        kiosk: require('@/public/kiosk/store'),
      },
    });
  });
}

sync(store, router);

export default store;
